import {axios} from 'services/axios';

export default function createACSService(body) {
    return axios.post(`/Service/ACSDirectRouting`, body);
}
